import { useTranslation } from '../../services/translations';

import TableRow from './TableRow';
import * as S from './CampaignsTable.styles';

type HeaderType = {
  [keys: string]: string;
};

type CampaignTableProps = {
  headers: HeaderType;
  subHeaders?: HeaderType;
  subOptionsKey?: string;
  tableData: {
    [keys: string]: string | number | object | boolean | object[];
  }[];
  formatRow?: {
    [keys: string]: Function;
  };
  formatSubRow?: {
    [keys: string]: Function;
  };
  actions: {
    action: Function;
    icon: string;
    title: string;
  }[];
};

const CampaignTable = ({
  headers,
  subHeaders,
  tableData,
  actions,
  formatRow,
  formatSubRow,
  subOptionsKey
}: CampaignTableProps) => {
  const { t } = useTranslation();
  return (
    <S.Table>
      <thead>
        <S.TableRow>
          {Object.values(headers).map((header, index) => (
            <S.TableHeaders key={index}>{header}</S.TableHeaders>
          ))}
          <S.TableHeaders>{t('table.actions')}</S.TableHeaders>
        </S.TableRow>
      </thead>
      <tbody>
        {tableData.map((dataGroup, index) => (
          <TableRow
            key={index}
            headers={headers}
            formatRow={formatRow}
            formatSubRow={formatSubRow}
            data={dataGroup}
            actions={actions}
            subHeaders={subHeaders}
            isOdd={index % 2 === 0 ? true : false}
            subOptionsKey={subOptionsKey}
          />
        ))}
      </tbody>
    </S.Table>
  );
};

export default CampaignTable;
